module.exports = __webpack_public_path__ + "static/limit-subcategories-on-the-sidebar-a9d0785acb4fcd13f287f4bebf2656f0.png";